/* global ajaxFails */
import React, {Component} from "react";
import TopNav from '../components/TopNav';
import './Helper/helper';
import Util from '../util/UtilClass';
import MenuItemModal from './modal/MenuItemModal';
import { Route, } from 'react-router-dom';
import TableSessionHelper from '../Model/TableSession';
import MenuItemThumbnailImage from './components/MenuItemThumbnailImage';
import ReactHelper from '../util/ReactHelper'
import OrderSetButton from './components/OrderSetButton';
import {isPickupOrDelivery, SpicyIndicator} from './MenuItem';
import ModuleHelper, { moduleKey } from '../app/User/Helper/ModuleHelper';

let lastOrderingSetNumber = 1
class NewMenuItemContent extends Component {
    constructor(props) {
        super(props)

        let categoryID;
        if (this.props.category != null) {
            // deprecated
            categoryID = this.props.category.id;
        } else {
            categoryID = this.props.match.params.categoryID;
        }
        this.state = {
            category: null,
            pin: Util.getRandomNumber(),
            orderingMenuItem: null,
            table: {
                id: table_id
            },
            tables: [],
            categories: [],
            menuItems: [],
            take_away: 0,
            variations: [],
            addons: [],
            options: [],
            selectedAddOns: [],
            selectedOptions: [],
            orderItems: [],
            orders: [],
            newMenuItem: {
                name: "",
                price: "",
                // merchant_id: props.merchant.id,
                table_id: table_id,
                category_id: categoryID
            },
            onClickHrefCategory: false,
            scrollStatus:'',

            // Economy rice order style
            isOrderSetBySet: false,
            orderingSetNumber: lastOrderingSetNumber,

            // We will display to user the index of the element (base 1 instead of base 0),
            // but we store the actual setNumber to DB.
            // This to avoid confusion where user created Set 1, Set 2 & Set 3
            // then later delete Set 2, resulting the remaining item Set 1 & Set 3
            // Our logic here
            // [
            //     0: setNumber1, <-- Display 0+1 = Set 1
            //     1: setNumber2, <-- Display 1+1 = Set 2
            //     2: setNumber3, <-- Display 2+1 = Set 3
            // ]
            // later if user delete setNumber2 we will have
            // [
            //     0: setNumber1, <-- Display 0+1 = Set 1
            //     1: setNumber3, <-- Display 1+1 = Set 2
            // ]
            // This way we do not need to change the DB record to re-number the set number
            // when set is deleted
            setNumbers: [],
        }

        this.navRefs = React.createRef()
        this.menuListingRef = React.createRef()
        this.orderSetButtonRef = React.createRef()

        this.onBackButtonClicked = this.onBackButtonClicked.bind(this)
        this.billClicked = this.billClicked.bind(this)
        this.onItemBackButtonClicked = this.onItemBackButtonClicked.bind(this)
        this.getMenuListing = this.getMenuListing.bind(this)
        // this.getMenuModalButtons     = this.getMenuModalButtons.bind(this)
        // this.getMenuModalBody           = this.getMenuModalBody.bind(this)
        // this.handleNewMenuItemChange    = this.handleNewMenuItemChange.bind(this)
        this.menuItemSelected = this.menuItemSelected.bind(this)
        this.btnPlusClicked = this.btnPlusClicked.bind(this)
        this.btnMinusClicked = this.btnMinusClicked.bind(this)
        this.btnAddOnClicked = this.btnAddOnClicked.bind(this)
        this.btnOptionClicked = this.btnOptionClicked.bind(this)
        this.btnChoiceClicked = this.btnChoiceClicked.bind(this)

        this.getChoicesListing = this.getChoicesListing.bind(this)
        this.getVariationsListing = this.getVariationsListing.bind(this)
        this.getOptionsListing = this.getOptionsListing.bind(this)

        this.getPinModalBody = this.getPinModalBody.bind(this)
        this.createTableSession = this.createTableSession.bind(this)
        this.showPinNumber = this.showPinNumber.bind(this);

        this.menuItemListRef = React.createRef()
        this.categoryItemListRef = React.createRef()
        this.categoryTitleRefs = []
        this.categoryItemRefs = []
        this.scrollTimeout = null;

        this.outOfStockItem = {}
    }

    componentWillUnmount() {
        $(document).off('menu-item-modal.is-ordering.success', this.handleOrderChanged)
    }

    componentDidMount() {
        this.props.app.loadTableIfNull(table_id)

        $(document).off('NewMenuItem.ScrollTo').on('NewMenuItem.ScrollTo', (e, params) => {
            let categoryTitle = this.categoryTitleRefs.find(a => a.category_id == params.categoryId)
            if (categoryTitle && categoryTitle.ref.current) {
                console.log(categoryTitle.ref.current.offsetLeft)
                document.querySelector('#menu-item-list').scrollTo({
                    behavior: "smooth",
                    left: categoryTitle.ref.current.offsetLeft,
                    top: categoryTitle.ref.current.offsetTop,
                })
            }
        })

        $(document).on('menu-item-modal.is-ordering.success', this.handleOrderChanged)

        // We are using some custom logic here where menuListing will
        // only be rendered after TopNav is rendered successfully,
        // as we need some properties from TopNav to correctly position
        // menuListing.
        // However, on first render, after TopNav (navRefs) is rendered,
        // React attempts to render menuListing before navRefs is set
        // successfully, therefore menuListing is not rendered.
        //
        // If this is the case, we force React to rerender again after
        // navRefs is set
        if (this.navRefs.current && !this.menuListingRef.current) {
            this.forceUpdate()
        }
        this.onMenuScroll()

        this.setIsOrderSetBySet()
    }

    handleOrderChanged = (e, order) => {
        // When order changed, we try to update the orderingSetNumber to match the
        // set_number of latest order
        if (order && order.set_number) {
            this.setState({orderingSetNumber: parseInt(order.set_number)})
        }
    }

    componentDidUpdate() {
        if (this.props.app !== undefined && this.props.app.state.categories != null && this.state.category === null) {
            let categories = this.props.app.state.categories;
            let selectedCategory;
            for (let category in categories) {
                if (categories[category].id == this.props.match.params.categoryID) {
                    selectedCategory = categories[category];
                    break;
                }
            }
            this.setState({
                category: selectedCategory
            });
        }
        if (this.state.currentCategory == null) {
            this.onMenuScroll()
        }

        ReactHelper.handleComponentDidUpdate(this, ["merchantSettings"], () => {
            this.setIsOrderSetBySet()
        })

        if (ModuleHelper.moduleEnabled(moduleKey.INVENTORY)) {
            ReactHelper.handleComponentDidUpdate(this, ["orders"], () => {
                this.updateOutOfStockItems()
            })
        }
    }
    updateOutOfStockItems = () => {
        (this.props.app.state.menuItems || []).forEach((menuItem) => {
            const remainingQuantity = this.getRemainingQuantity(menuItem)
            this.outOfStockItem[menuItem.id] = remainingQuantity < 1
        })
    }
    getRemainingQuantity = (menuItem) => {
        let remainingQuantity = 999 // Default we set to some large positive number
        if (menuItem && menuItem.track_inventory && ModuleHelper.moduleEnabled(moduleKey.INVENTORY)) {
            // If has inventory tracking, get remaining quantity
            remainingQuantity = menuItem.getInventoryRemainingQuantity()
        }
        return remainingQuantity
    }
    setIsOrderSetBySet = () => {
        this.setState({
            isOrderSetBySet: this.props.app.isOrderSetBySet(),
        })
    }
    onMenuItemModalSetNumberChange = (orderingSetNumber) => {
        // Only update the orderingSetNumber if the newly selected setNumber exist
        // in current setNumber list
        if (this.orderSetButtonRef.current) {
            let setNumbers = this.orderSetButtonRef.current.getSetNumbers()
            orderingSetNumber = parseInt(orderingSetNumber)
            const setNumberExists = setNumbers.indexOf(orderingSetNumber) !== -1
            if (setNumberExists) {
                this.onSetNumberChange(orderingSetNumber)
            }
        }
    }
    onSetNumberChange = (orderingSetNumber) => {
        lastOrderingSetNumber = orderingSetNumber
        this.setState({
            orderingSetNumber: orderingSetNumber
        })
    }

    isMenuItemShowImage = () => {
        let a = this.props.app.isMerchantHasFeature('menu_item_user_mode_show_image')
        return a
    }

    isPickupOrDelivery = () => {
        return isPickupOrDelivery(this.props.app.state.table)
    }
    getPrice = (isPickupOrDelivery) => {

    }

    getItemHeader(menuItem, allowUseMerchantImage, forceUseMerchantImage) {
        const isOutOfStock = this.isItemOutOfStock(menuItem) ? ` (${lang.out_of_stock})` : ""
        const isMenuItemShowImage = this.isMenuItemShowImage()

        let itemDetail = null
        let itemPrice = null
        let selectedChoices = this.props.app.state.variation.selectedChoices.filter((item) => item.item_id == menuItem.id)
        let isSubtitleExist =
        menuItem.subtitle ? <span style={{ fontSize: "12px", color: "#909090", fontStyle: "italic", minWidth: "50%", display: "inline-block" }}>{menuItem.subtitle}</span> : ""
        if(selectedChoices.length == 0){
            const price = this.isPickupOrDelivery() && menuItem.price_delivery != null ? menuItem.price_delivery : menuItem.price
            itemPrice = <div style={{fontWeight: "bold"}}>{this.props.currencyName+" "+ (price * 1).toFixed(2)}</div>
        }
        else{
            const choice = selectedChoices[0]
            const price = this.isPickupOrDelivery() && choice.price_delivery != null ? choice.price_delivery : choice.price
            itemPrice = <div style={{fontWeight: "bold"}}>{this.props.currencyName+" " + (price * 1).toFixed(2)}</div>
        }

        const inventoryRemaining = this.getRemainingQuantity(menuItem)

        return (
            <div style={{ position: "relative", fontWeight: "bold", display: "flex", alignItems: "center", marginTop: "20px", marginLeft: "10px", marginBottom: "20px" }}>
                {isMenuItemShowImage &&
                    <span className="mr-3">
                        <MenuItemThumbnailImage menuItem={menuItem} allowUseMerchantImage={!!allowUseMerchantImage} forceUseMerchantImage={!!forceUseMerchantImage} />
                    </span>
                }
                <span style={{flex: "1 0 100px"}}>
                    <span style={{marginRight: "5px"}}>{menuItem.name + isOutOfStock}</span>
                    <span>
                        <SpicyIndicator level={menuItem.meta && menuItem.meta.meta && menuItem.meta.meta.spicy} />
                        {
                            menuItem.hot_product == '1' && <i className="far fa-thumbs-up fa-2x hot-pick" style={{ marginLeft: '5px',}} />
                        }
                    </span>

                    <br/>
                        {isSubtitleExist}
                    <div style={{ fontWeight: "bold", flex: "0 0 1" }}>
                        {itemPrice}
                    </div>
                </span>
                {
                    inventoryRemaining < 10 && inventoryRemaining > 0 &&
                    <div style={{ position: "absolute", bottom: "10px", right: "10px", fontSize: "14px", color: "#909090", fontStyle: "italic", textAlign: "right", minWidth: "100px", display: "inline-block"}}>
                        ({`Only ${inventoryRemaining} left`})
                    </div>
                }
            </div>
        )
    }
    getMenuItemWithId(menuItemId) {
        let menuItem = this.props.app.state.menuItems.find((item) => item.id == menuItemId)
        return menuItem
    }
    menuItemSelected(e) {
        let id = e.currentTarget.dataset.id * 1
        let menuItem = this.getMenuItemWithId(id)

        if (this.isItemOutOfStock(menuItem)) {
            alert(lang.item_out_of_stock)
            return
        }

        this.setState({
            orderingMenuItem: menuItem
        })
        this.props.history.push(`/menu/${this.props.match.params.categoryID}/order/${id}/${this.props.match.params.tableQR}`)
        $(document).trigger('MenuItemContent.menuItemClicked')
    }

    isItemOutOfStock = (menuItem) => {
        return this.outOfStockItem[menuItem.id] || menuItem.is_out_of_stock || menuItem.is_out_of_stock_until
    }

    getMenuListing(isHasBackgrounImage) {
        let me = this
        let index = 0

        let menuItemList = this.props.app.state.menuItems
        menuItemList.sort(function(a,b) {return a.sequence - b.sequence})

        let fullItemList = []
        const forceUseMerchantImage = this.props.app.isMerchantHasFeature('force_use_merchant_menu_item_image_as_default_user_menu_item_image')
        const allowUseMerchantImage = this.props.app.isMerchantHasFeature('use_merchant_menu_item_image_as_default_user_menu_item_image')
        this.props.app.state.filteredCategories.filter(c => c.active).map(category => {
            // this.props.app.state.categories.filter(c => c.active).map(category => {
            let itemList = menuItemList.filter(item => item.category_id == category.id)
            let li = itemList.map((menuItem) => {
                if (menuItem.category_id == null) {
                    return null
                }
                const isOutOfStock = this.isItemOutOfStock(menuItem) ? 'left-border-warning' : ""
                if (menuItem.active) {
                // if (this.props.match.params.categoryID == menuItem.category_id && menuItem.active) {
                    index++;
                    //list-group-item
                    if (!menuItem.is_section_header) {
                        return <li
                            id={`menu-item-${menuItem.id}`}
                            className={'clearfix ' + isOutOfStock}
                            data-index={index}
                            style={
                                {
                                    verticalAlign: "middle",
                                    // backgroundColor: "rgba(255, 255, 255, 0.8)",
                                }
                            }
                            key={menuItem.id}
                            onClick={(e) => {

                                // if table is lock .. click join table ... if join table success... open menu
                                let isNotYetJoinActiveTable = TableSessionHelper.isNeedToTriggerJoinTable()
                                if (isNotYetJoinActiveTable) {
                                    this.props.app.setState({
                                        joiningTable: true
                                    })
                                } else {
                                    this.menuItemSelected(e)
                                }
                            }}
                            data-id={menuItem.id}>
                            {this.getItemHeader(menuItem, allowUseMerchantImage, forceUseMerchantImage)}
                        </li>
                    }
                    else {
                        return <li
                            key={menuItem.id}
                            data-id={menuItem.id}
                            style={{
                                listStyle: "none",
                            }}>
                            {menuItem.name}
                        </li>
                    }
                }
            })

            let ref = null
            let refIndex = this.categoryTitleRefs.findIndex(c => c.category_id == category.id)
            if (refIndex === -1) {
                let ref = React.createRef()
                this.categoryTitleRefs.push({
                    category_id: category.id,
                    ref: ref,
                })
            }
            else {

                ref = this.categoryTitleRefs[refIndex].ref
            }
            li.unshift(<li className="cat-title-background" ref={ref} id={"Cat" + (category.id)} key={"Cat-"+category.id} style={{fontWeight:"bold", lineHeight:"50px" }}><span className="cat-title" style={{marginLeft: "10px", fontSize: "14px"}}>{category.name}</span></li>)
            fullItemList = fullItemList.concat(li)
        })
        return fullItemList
    }


    onBackButtonClicked() {
        this.props.backClicked()
    }

    billClicked() {
        this.setState({
            checkOrder: true
        })
    }

    onItemBackButtonClicked() {
        this.setState({
            checkOrder: false
        })
    }

    getItemId() {
        let $itemCategory = this.state.category.id;
        let $itemName = $('#iname').val();

        // let menuItem = this.props.app.state.menuItems.find(item => item.category_id === itemCategory && item.name === itemName)
        let menuItem = this.props.app.state.menuItems.filter(function (item) {
            let $abc = (item.category_id == $itemCategory);
            let $xyz = (item.name == $itemName);
            if (item.category_id == $itemCategory && item.name == $itemName)
                return item;
        });

        return menuItem[0].id;
    }

    getPinModalBody() {
        return (
            <div style={{ witdh: "100%" }}>
                {/* <div id="category-title" className="category-modal-field">
                    <h3>{lang.category}: {this.state.category !== null ? this.state.category.name : ""} </h3>
                </div> */}
                <span style={{ fontSize: "20px", display: "block" }}>{lang.pin_random}</span>
                <span style={{ color: "red", fontWeight: "bold" }}><i>{lang.pin_random_desc}</i></span>
                <div style={{ textAlign: "center" }}>
                    <span id="random-number" style={{ fontSize: "60px", padding: "0 10px", fontWeight: "bold" }}></span>
                </div>
                <div style={{ width: "100%", height: "25px", borderBottom: "1px solid black", textAlign: "center" }}>
                    <span style={{ fontSize: "30px", backgroundColor: "#ffffff", padding: "0 10px" }}>Or</span>
                </div>
                <div style={{ marginTop: "40px" }}>
                    <span style={{ fontSize: "20px" }}>{lang.pin_enter}</span>
                </div>
                <div id="pin-value">
                    <div style={{ borderLeft: "6px solid black", height: "30%" }}></div>
                    {/* <input type="number" min="1" className="form-control" id="pin-input" placeholder={lang.hint_enter_pin}
                        onKeyDown={this.validate} pattern="\d{1,5}" /> */}
                    <input type="text" maxLength="4" value={this.state.pin || ""} onChange={this.pinChange.bind(this)}
                        className="form-control" id="pin-input" placeholder={lang.hint_enter_pin} />
                </div>
            </div>
        )
    }
    pinChange(value) {
        let regex = /^[0-9]{0,4}$/g
        if (regex.test(value)) {
            this.setState({
                pin: value
            })
        }
    }

    getConfirmOrderBody() {
        return (
            <div style={{ witdh: "100%" }}>
                <div id="order-title" className="category-modal-field">
                    {lang.asking_order}
                </div>
            </div>
        )
    }

    handleOrderQuantityChanged(menuItem, change) {
        switch (change) {
            case "+":
                menuItem.newOrderQuantity++
                break;
            case "-":
                // Handle make sure do not go zero
                menuItem.newOrderQuantity -= (menuItem.newOrderQuantity > 1) * 1
                break;
        }
        this.forceUpdate()
    }

    btnPlusClicked(e) {
        e.stopPropagation()
        let id = e.currentTarget.dataset.id * 1
        let menuItem = this.getMenuItemWithId(id)
        this.handleOrderQuantityChanged(menuItem, '+')
    }

    btnMinusClicked(e) {
        e.stopPropagation()
        let id = e.currentTarget.dataset.id * 1
        let menuItem = this.getMenuItemWithId(id)
        this.handleOrderQuantityChanged(menuItem, '-')
    }

    createTableSession(pin) {
        let me = this

        return new Promise(
            (resolve, reject) => {
                $.ajax({
                    url: "/table/" + me.props.app.state.table.id + "/join_table",
                    type: "post",
                    data: {
                        merchant_id: me.props.app.state.table.merchant_id,
                        table_id: me.props.app.state.table.id,
                        pin: pin
                    },
                    success: function (response) {
                        let message = lang.your_pin
                        let result = message.replace("*PIN*", pin)
                        alert(result)
                        table_session_id = response['id']
                        $('#table-pin-modal').modal('hide')
                        me.props.app.newSession();
                        resolve()
                        // me.forceUpdate()
                    },
                    fail: function (e) {
                        console.error(e)
                        alert(e)
                        reject()
                    }
                })
            })
    }

    pickItem = (menuItem, animation = true) => {
        if (menuItem.newOrderQuantity < 1) {
            return
        }

        let labelId = '#order-label-' + menuItem.id;
        let desc = $(labelId).text();

        let remarkId = '#order-remark-' + menuItem.id;
        let remarkValue = $(remarkId).val();

        let variations = '';
        let addons = this.props.app.state.variation.selectedAddOns.filter((item) => item.item_id == menuItem.id)
        if (addons.length > 0) {
            addons.map((addon) => {
                if (variations.length > 0)
                    variations = variations + ",";

                variations = variations + addon.name;
            })
        }

        let options = this.props.app.state.variation.selectedOptions.filter((item) => item.item_id == menuItem.id)
        if (options.length > 0) {
            options.map((option) => {
                if (variations.length > 0)
                    variations = variations + ", ";

                variations = variations + option.name;
            })
        }

        let totalPrice = this.getTotalPriceString(menuItem.id)//$('#total-price').text().replace("RM ", "");
        let isTakeAway = $('#checkbox-takeaway-' + menuItem.id).prop("checked") ? 1 : 0
        $.ajax({
            url: '/orders',
            type: 'post',
            data: {
                // order_session_id : session_id,
                menu_item_id: menuItem.id,
                quantity: menuItem.newOrderQuantity,
                remark: remarkValue,
                variations: variations,
                merchant_id: this.props.app.state.table.merchant_id,
                table_id: this.props.app.state.table.id,
                order_total: totalPrice,
                table_session_id: table_session_id,
                take_away: isTakeAway,
                desc: desc,
                set_number: this.state.orderingSetNumber || 1,
            },
            success: (response) => {
                $('#place-order-button').fadeIn('slow');
            }
        }).fail(ajaxFails)
        if (animation) {
            this.animationMove(menuItem);
        }
    }

    animationMove(menuItem) {
        let btn = $('#btn-confirm-' + menuItem.id)
        let bottom = btn.offset().top - $('#bill-button').offset().top + 16
        let me = this
        btn.animate({
            bottom: bottom, height: "0%", width: "0%", opacity: '0.5', fontSize: "1px"
        },
            1000, function () {

                me.resetMenu(menuItem);
                me.forceUpdate()

                $('#bill-button').fadeOut(400, function () {
                    $('#bill-button').fadeIn(400);
                });
                $('#bill-count').fadeOut(400, function () {
                    $('#bill-count').fadeIn(400);
                });
            }
        );
    }

    resetMenu(menuItem) {
        let remarkId = '#order-remark-' + menuItem.id;
        $(remarkId).val("");

        menuItem.newOrderQuantity = 1

        var variation = this.props.app.state.variation;
        // variation.selectedChoices = [];
        variation.selectedAddOns = [];
        variation.selectedOptions = [];
        this.props.app.setState({
            variation: variation
        })
    }

    getChoicesListing(menuItem) {
        let listChoices = this.props.app.state.variation.choices
        listChoices.sort(function (a, b) { return a.sequence - b.sequence })
        let li = listChoices.filter(item => (item.item_id == menuItem.id)).map((choice) => {
            let value = (choice.price > 0) ? " " + (choice.price * 1).toFixed(2) : " " + (choice.price * 1).toFixed(2);
            return (this.props.app.state.variation.selectedChoices.indexOf(choice) > -1) ?
                <button key={choice.id} data-id={choice.id} style={{ marginLeft: "10px", marginBottom: "5px" }} type="button" className="btn btn-sm btn-primary" onClick={this.btnChoiceClicked}>{choice.name + value}</button> :
                <button key={choice.id} data-id={choice.id} style={{ marginLeft: "10px", marginBottom: "5px" }} type="button" className="btn btn-sm btn-default" onClick={this.btnChoiceClicked}>{choice.name + value}</button>
        })
        return li
    }

    getVariationsListing(menuItem) {
        let li = this.props.app.state.variation.addons.filter(item => (item.item_id == menuItem.id)).map((addon) => {
            let value = (addon.price > 0) ? " +" + (addon.price * 1).toFixed(2) : " " + (addon.price * 1).toFixed(2);
            return (this.props.app.state.variation.selectedAddOns.indexOf(addon) > -1) ?
                <button key={addon.id} data-id={addon.id} style={{ marginLeft: "10px", marginBottom: "5px" }} type="button" className="btn btn-sm btn-primary" onClick={this.btnAddOnClicked}>{addon.name + value}</button> :
                <button key={addon.id} data-id={addon.id} style={{ marginLeft: "10px", marginBottom: "5px" }} type="button" className="btn btn-sm btn-default" onClick={this.btnAddOnClicked}>{addon.name + value}</button>
        })
        return li
    }

    getOptionsListing(menuItem) {
        let li = this.props.app.state.variation.options.filter(item => (item.item_id == menuItem.id)).map((option) => {
            return (this.props.app.state.variation.selectedOptions.indexOf(option) > -1) ?
                <button key={option.id} data-id={option.id} style={{ marginLeft: "10px", marginBottom: "5px" }} type="button" className="btn btn-sm btn-primary" onClick={this.btnOptionClicked}>{option.name}</button> :
                <button key={option.id} data-id={option.id} style={{ marginLeft: "10px", marginBottom: "5px" }} type="button" className="btn btn-sm btn-default" onClick={this.btnOptionClicked}>{option.name}</button>
        })
        return li
    }

    btnChoiceClicked(e) {
        e.stopPropagation()
        let id = e.currentTarget.dataset.id * 1
        let choice = this.props.app.state.variation.choices.find((item) => item.id == id)
        let menuItem = this.getMenuItemWithId(choice.item_id)

        //Clear choice
        let variation = this.props.app.state.variation;
        let selectedChoice = []
        let i = 0
        for (i = 0; i < variation.selectedChoices.length; i++) {
            if (variation.selectedChoices[i].item_id != choice.item_id) {
                selectedChoice.push(variation.selectedChoices[i])
            }
        }

        selectedChoice.push(choice)
        variation.selectedChoices = selectedChoice

        let totalPrice = parseFloat(choice.price);
        totalPrice = totalPrice * menuItem.newOrderQuantity;
        variation.totalPrice = totalPrice;

        this.props.app.setState({
            variation: variation
        })
    }

    btnAddOnClicked(e) {
        e.stopPropagation()
        let id = e.currentTarget.dataset.id * 1
        let addon = this.props.app.state.variation.addons.find((item) => item.id == id)
        let menuItem = this.getMenuItemWithId(addon.item_id)

        let check = this.props.app.state.variation.selectedAddOns.find((item) => item.id == id)
        if (check == null || check.length == 0) {
            let variation = this.props.app.state.variation;
            variation.selectedAddOns.push(addon);

            let totalPrice = parseFloat(menuItem.price) + parseFloat(addon.price);
            totalPrice = totalPrice * menuItem.newOrderQuantity;
            variation.totalPrice = totalPrice;

            this.props.app.setState({
                variation: variation
            })
        }
        else {
            let res = []
            let totalPrice = parseFloat(menuItem.price);

            this.props.app.state.variation.selectedAddOns.forEach(function (selectedAddon) {
                if (selectedAddon.id != addon.id) {
                    res.push(selectedAddon)
                    totalPrice = totalPrice + parseFloat(selectedAddon.price)
                }
            });
            totalPrice = totalPrice * menuItem.newOrderQuantity

            let variation = this.props.app.state.variation;
            variation.selectedAddOns = res;
            variation.totalPrice = totalPrice;

            this.props.app.setState({
                variation: variation
            })
        }
    }

    btnOptionClicked(e) {
        e.stopPropagation()
        let id = e.currentTarget.dataset.id * 1
        let option = this.props.app.state.variation.options.find((item) => item.id == id)

        let check = this.props.app.state.variation.selectedOptions.find((item) => item.id == id)
        if (check == null || check.length == 0) {
            let variation = this.props.app.state.variation;
            variation.selectedOptions.push(option);

            this.props.app.setState({
                variation: variation
            })
        }
        else {
            let res = [];
            let variation = this.props.app.state.variation;
            this.props.app.state.variation.selectedOptions.forEach(function (selectedOption) {
                if (selectedOption.id != option.id)
                    res.push(selectedOption)
            });

            variation.selectedOptions = res;
            this.props.app.setState({
                variation: variation
            })
        }
    }

    showSelectedAddOns(selectedAddOns) {
        let li = selectedAddOns.map((addon) => {
            let value = (addon.price > 0) ? " +" + (addon.price * 1).toFixed(2) : " " + (addon.price * 1).toFixed(2);
            return <span key={addon.id} style={{ color: "red", display: "block", textAlign: "right" }}>{" " + addon.name + this.props.currencyName + " " + value}</span>
        })
        return li
    }

    showSelectedOptions(selectedOptions) {
        let li = selectedOptions.map((option) => {
            return <span key={option.id} style={{ color: "blue" }}>{" " + option.name}</span>
        })
        return li
    }

    enterRemark(menuItem) {
        let remarkId = "order-remark-" + menuItem.id;
        return <input key={menuItem.id} type="text" style={{ width: "260px" }} className="form-control" id={remarkId} maxLength="30" placeholder={lang.hint_max_char} />
    }

    getTotalPriceString(itemId) {
        let menuItem = this.getMenuItemWithId(itemId)

        let totalPrice = 0;
        let selectedChoices = this.props.app.state.variation.selectedChoices.filter((item) => item.item_id == itemId)
        if (selectedChoices.length > 0) {
            selectedChoices.map((choice) => {
                totalPrice = parseFloat(choice.price);
            })
        }
        else {
            totalPrice = parseFloat(menuItem.price);
        }

        if (this.props.app.state.variation.selectedAddOns.length > 0) {
            let selecteds = this.props.app.state.variation.selectedAddOns.filter((item) => item.item_id == itemId)
            selecteds.map((addon) => {
                totalPrice = totalPrice + parseFloat(addon.price);
            })
        }

        if ($('#checkbox-takeaway-' + menuItem.id).prop('checked')) {
            totalPrice = totalPrice + parseFloat(menuItem.take_away_charge)
        }

        totalPrice = totalPrice * menuItem.newOrderQuantity
        return (totalPrice * 1).toFixed(2)
    }

    getTotalPrice(itemId) {
        return <span key={itemId} id="total-price" style={{ fontWeight: "bold" }}>{this.props.currencyName} &nbsp; {this.getTotalPriceString(itemId)}</span>
    }

    getOrderBill(category) {
        let count = this.props.orders.length
        if (count > 0) {
            let draft = false
            let orderId = 0;
            this.props.orders.map((order) => {
                if (order.order_status == "draft") {
                    draft = true;
                    orderId = order.id;
                }
            })

            if (draft) {
                var flash = setInterval(function () {
                    $('#place-order-button').fadeTo('slow', 0.5).fadeTo('slow', 1.0);
                }, 3000)
            }
            else {
                clearInterval(flash);
            }

            return [
                <div key={"menu-" + category.id}>
                    <button id="bill-button" className="btn btn-default pull-right" onClick={this.billClicked}>{lang.my_order}</button>
                    <span id="bill-count" className="label label-danger pull-right order_dot" key={"table-" + this.props.table.id} style={{ marginRight: "10px", position: "absolute", right: "0px" }}>{count}</span>
                    <button id="place-order-button" data-id={orderId} key={orderId} style={{ display: draft ? "initial" : "none", marginRight: "5px" }} className="btn btn-danger pull-right" onClick={this.confirmedOrder}><strong>{lang.place_order}</strong></button>
                </div>
            ]
        }
        else
            return <button id="bill-button" className="btn btn-default pull-right" onClick={this.billClicked}>{lang.my_order}</button>;
    }

    showPinNumber() {
        alert(lang.your_pin_number + this.props.app.state.table_session.pin);
    }

    confirmedOrder(e) {
        if (confirm(lang.asking_place_order)) {
            e.stopPropagation()
            let id = e.currentTarget.dataset.id * 1
            let order = this.props.orders.find((item) => item.id == id)

            $('#place-order-button').fadeOut('slow');
            $.ajax({
                url: `/orders/${order.id}/update_order_status`,
                type: 'post',
                data: {
                    order_id: order.id,
                    merchant_id: order.merchant_id,
                    table_id: order.table_id,
                    order_status: "accepted"
                },
                success: (response) => {
                    alert(lang.order_complete)
                    console.log(response)
                }
            }).fail(ajaxFails)
        }
    }

    onClickHrefCategory = () => {
        let onClickHrefCategory = true
        this.setState({ onClickHrefCategory: onClickHrefCategory })
    }

    handleULScroll = (event) => {
        if(this.scrollTimeout){ //if there is already a timeout in process cancel it
            clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.scrollTimeout = null;
            this.setState({
                scrollStatus:'scroll stopped',
                onClickHrefCategory: false,
            });
        }, 50);
        if(this.state.scrollStatus !== 'scrolling') {
            this.setState({
                scrollStatus:'scrolling'
            });
        }
    }

    render() {
        if (!this.props.app.isReadyFor(this)) {
            return (<div></div>);
        }
        let image_path = (this.props.app.state.merchant && this.props.app.state.merchant.logo_url)?this.props.app.state.merchant.display_logo : "";
        let styling = this.props.app.isMerchantHasFeature('show_background_image_in_user_app')
        return (
            <div>
                <Route path="/menu/:categoryID/order/:menuItemId/:tableQR" exact
                    render={({ history, match }) => {
                        let onDismissGoToUrl = `/menu/${match.params.categoryID}/${match.params.tableQR}`
                        const extraSetNumbers = this.orderSetButtonRef.current && this.orderSetButtonRef.current.getSetNumbers()
                        return <MenuItemModal
                            app={this.props.app}
                            setNumber={this.state.orderingSetNumber || 1}
                            isPickupOrDelivery={this.isPickupOrDelivery()}
                            menuItem={this.getMenuItemWithId(match.params.menuItemId)}

                            // For OrderSetButton
                            // Update set number when user update set number at menu item modal
                            onSetNumberChange={this.onMenuItemModalSetNumberChange}
                            extraSetNumbers={extraSetNumbers}

                            onClose={() => {
                                this.props.history.replace(onDismissGoToUrl);
                            }}
                        />
                    }
                    } />
                <TopNav
                    ref={this.navRefs}
                    isAllowSearchbar={true}
                    tableQR={this.props.match.params.tableQR}
                    table={this.props.app.state.table}
                    topTitle={`${lang.category}: ${this.state.category !== null ? this.state.category.name : ""}`}
                    title={lang.menu_item}
                    orders={this.props.app.state.orders}
                    // action={this.addMenuItem}
                    actionLabel={this.props.app.state.isMerchant ? "+" : null}
                    back={"/category/" + this.props.match.params.tableQR}
                    pin={this.props.app.state.table_session !== null && table_session_id !== null ? <button className="btn btn-primary btn-sm" onClick={this.showPinNumber}>{lang.show_pin}</button> : ""}
                    session={this.props.app.state.current_session}
                    backLabel={lang.menu}
                />
                <div className="" style={{display: "relative", ...styling}}>
                {
                    this.navRefs.current && this.navRefs.current.navHeight && <div ref={this.menuListingRef} className="container body-content" style={{overflow: "auto", paddingTop: this.navRefs.current.navHeight ? parseInt(this.navRefs.current.navHeight) + "px" : "70px", paddingRight: "0px", paddingLeft: "0px" }}>
                        <div className={`${styling ? "white-translucent" : ""}`} style={{display: "flex", height: this.getMenuItemListHeight(), }}>
                            <div style={{flex: "0 0 110px", justifyContent: "center", textAlign: "center", height: "100%"}}>
                                <ul id="categoryBar" ref={this.categoryItemListRef}
                                    style={{maxWidth: "110px", padding:"0px", marginLeft: "auto", marginRight: "auto",
                                        overflow: "hidden", overflowY: "scroll", scrollBehavior: "smooth",
                                        height: "100%", paddingBottom: this.getMenuItemPaddingBottom()}}>
                                {
                                    this.props.app.state.filteredCategories.map((category, index) => {
                                        if(category.active == 0){
                                            return "";
                                        }

                                        let imageUrl = category.getImageUrl()
                                        let ref = null
                                        let refIndex = this.categoryItemRefs.findIndex(c => c.category_id == category.id)
                                        if (refIndex === -1) {
                                            let ref = React.createRef()
                                            this.categoryItemRefs.push({
                                                category_id: category.id,
                                                ref: ref,
                                            })
                                        }
                                        else {
                                            ref = this.categoryItemRefs[refIndex].ref
                                        }

                                        return <a ref={ref} key={category.id} href={"#Cat"+category.id} onClick={this.onClickHrefCategory}>
                                            <li className={category.id == this.state.currentCategory ? "cat-active" : "cat-inactive"} style={{wordBreak: "keep-all", minHeight: "70px", fontSize: "8pt", marginBottom: "10px"}}>
                                                <div style={{margin: "auto"}}>
                                                    <img src={imageUrl} style={{ccheight: "60px", width: "85%"}} />
                                                </div>
                                                <div>{category.name}</div>
                                            </li>
                                        </a>
                                    })
                                }
                                </ul>
                            </div>
                            <div style={{flex: "1 0 100px", height: "100%", borderLeft: "1px solid grey" }} onScroll={this.handleULScroll}>
                                <ul id="menu-item-list" className="list-group" ref={this.menuItemListRef} style={{overflowY: "scroll", scrollBehavior: "smooth", overflowX: "hidden", height: "100%", paddingBottom: this.getMenuItemPaddingBottom()}} onScroll={this.onMenuScroll}>
                                    {this.getMenuListing()}
                                </ul>
                            </div>
                        </div>

                        {
                            this.hasDraftOrders() && this.state.isOrderSetBySet &&
                            <div className="order-to-set" style={{display: "flex", width: "100%"}}>
                                <OrderSetButton
                                    ref={this.orderSetButtonRef}
                                    orders={this.props.app.state.orders}
                                    defaultOrderingSetNumber={this.state.orderingSetNumber}
                                    onSetNumberChange={this.onSetNumberChange} />
                            </div>
                        }
                    </div>
                }
                </div>
            </div>
        )
    }
    hasDraftOrders = () => {
        return this.props.app.state.orders && this.props.app.state.orders.length > 0
    }
    getOrderingSetHeight = () => {
        const currentOrderingSetHeight = 50
        if (this.hasDraftOrders()) {
            if (this.state.isOrderSetBySet) {
                return currentOrderingSetHeight
            }
        }
        return 0
    }
    getMenuItemPaddingBottom = () => {
        let paddingBottom = this.getOrderingSetHeight()
        return `${paddingBottom}px`
    }
    getMenuItemListHeight = () => {
        const navBarHeight = 67
        const footerHeight = 53
        const unknownOffset = 0

        let heightOffSet = navBarHeight + unknownOffset
        if (this.hasDraftOrders()) {
            heightOffSet += footerHeight + this.getOrderingSetHeight()
        }
        return `calc(100vh - ${heightOffSet}px)`
    }
    onMenuScroll = () => {
        // console.log(this.menuItemListRef.current.scrollTop)
        // console.log(this.categoryTitleRefs[1].ref.current.getBoundingClientRect().top)
        if (this.menuItemListRef.current == null) {
            return
        }
        let currentScrollTop = this.menuItemListRef.current.scrollTop
        let currentCategory = this.state.currentCategory || (this.props.app.state.categories && this.props.app.state.categories[0].id)
        for (let i = 0; i < this.categoryTitleRefs.length; i++) {
            let ref = this.categoryTitleRefs[i]
            if (ref.ref.current) {
                let rect = ref.ref.current.getBoundingClientRect()
                // console.log(rect)
                if (rect.top > 100) {
                    // found the visible category, so active category will be the one on top of it
                    currentCategory = i > 0 ? this.categoryTitleRefs[i-1].category_id : this.categoryTitleRefs[0].category_id
                    // console.log(this.menuItemListRef.current.scrollTop)
                    let cate = this.props.app.state.categories.find(c => c.id == currentCategory)
                    // console.log(cate && cate.name)
                    break;
                }
            }
        }
        if (currentCategory) {
            if (currentCategory != this.state.currentCategory || (this.props.app.state.categories && this.props.app.state.categories[0].id)) {
                this.setState({currentCategory}, () => {
                    let categoryRef = this.categoryItemRefs.find(itemRef => {
                        return itemRef.category_id == currentCategory
                    })
                    if (categoryRef) {
                        let categoryItemLi = categoryRef.ref.current
                        let rect = categoryItemLi.getBoundingClientRect()
                        let categoryListUl = this.categoryItemListRef.current
                        if (categoryListUl) {
                            let ulRect = categoryListUl.getBoundingClientRect()
                            if ((rect.top > ulRect.height) && !this.state.onClickHrefCategory) {
                                categoryItemLi.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'nearest'})
                            }
                            if ((rect.top < ulRect.height) && !this.state.onClickHrefCategory) {
                                categoryItemLi.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'nearest'})
                            }
                        }
                    }
                })
            }
        }
    }
}

export default NewMenuItemContent;

